<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
  export default {
    name: 'App',
    data () {
      return {
      }
    },
    watch:{
      "$route"(to,from){
        
      }
    },
    mounted () {
      this.fnResize()
      window.onresize =  () => {
        this.fnResize()
      }
    },
    methods:{
      fnResize () {
          var deviceWidth = document.documentElement.clientWidth || window.innerWidth
          if (deviceWidth >= 750) {
            deviceWidth = 750
          }
          if (deviceWidth <= 450) {
            deviceWidth = document.documentElement.clientWidth || window.innerWidth
          }
          document.documentElement.style.fontSize = ((deviceWidth) / 10) + 'px'
      }
    },
  }
</script>

<style lang="less">
#app {
  margin: 0 10px;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
